<template>
<main class="main-wrapper flex-grow-1 dkk111">
	<div class="d-flex align-items-center ">
			<div class="t-headline13 t-color-headlineBlack pda-14 font-m flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
					{{this.$t("212")}}
			</div>
	</div>
	<div class="divider"></div>
	<!-- subtabs -->
<top-app-bar-survey-list-tab></top-app-bar-survey-list-tab>

	<div class="container container--narrow mgt-30 category">
		<no-data :msgData="msgData" v-if="isNoData"></no-data>
			<!-- <img src="images/banner.svg" alt="" class="b-radius4"> -->
			<!-- <div class="mgt-30 d-flex justify-content-between">
					<div class="t-body6 t-color-bodyGrayA l-spacing45 t-line-h-22 font-r flex-grow-1">총 32개</div>
					<button class="material-icons mdc-icon-button test-list-toggler mgt--12 mgb--12">
						<img src="images/view-carousel-inactive.svg" alt=""></button>
					<button class="material-icons mdc-icon-button mgr--14  mgt--12 mgb--12 test-list-toggler active">view_list</button>
			</div> -->
			<!-- <div class="divider mgt-16 mgb-16"></div> -->
			<div class="d-flex justify-content-between align-items-baseline mgt-16 mgb-16" v-if="!isNoData">
					<div class="t-color-headlineBlack t-headline10 font-b t-line-h-33">{{ categoryName }}</div>
					<!-- <div class="t-color-secondaryBtnText t-body2 font-m t-line-h-22 l-spacing98">모두 보기</div> -->
			</div>
			<div class="mdc-card mgb-50 pdt-8 pdb-8">
					<div class="test-carousel-list-type pdt-16 pdb-16 pdl-24 pdr-24" v-for="(survey, index) in listData"
          :key="index">
							<div class="d-flex justify-content-between cursor-pointer" @click="viewDetail(survey.id)" @keypress="viewDetail(survey.id)" tabindex="0">
									<div class="flex-grow-1">
											<div class="t-headline7 font-m t-line-h-29 t-line-1">{{ survey.name }}</div>
											<div class="t-body6 font-r t-line-h-22 l-spacing45 mgt-4">{{ $t("218") }}</div>
									</div>
										<div  v-if="survey.earnPoint > 0" class="t-subtitle1 font-b d-flex align-items-center justify-content-center t-nowrap">
												<img src="@/assets/icon_point.svg" class="w-24 d-inline mgr-8" alt="">{{ $n(survey.earnPoint) }}
										</div>
										<div v-else class="t-subtitle1 font-b d-flex align-items-center justify-content-center t-nowrap">
												<img src="@/assets/icon_point.svg" class="w-24 d-inline mgr-8" alt="">0
										</div>
							</div>
					</div>
			</div>
							<infinite-loading @infinite="fetchData" spinner="spiral">
        <div slot="no-more" class="pdt-16 pdb-16"><!--No more data--></div>
        <div slot="no-results" class="pdt-16 pdb-16"></div>
      </infinite-loading>
	</div>
</main>
</template>

<script>
/**
 * 단독 설문 카테고리 목록  컴포넌트(independent survey category list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import surveyApi from "@/api/surveyApi.js";
import { MDCRipple } from "@material/ripple";
import NoData from "../../common/NoData.vue";
import InfiniteLoading from "vue-infinite-loading";
import TopAppBarSurveyListTab from "../../TopAppBarSurveyListTab.vue";
export default {
	name: "examCategory",
	data() {
		return {
			categoryName: "",
			isNoData: false,
			listData: [],
			currentPage: 1,
			totalPages: 1,
			currentDate: Date.now(),
			msgData:{
				msg1:'',
				msg2:''
			}
		};
	},

	components: {
		NoData,
		InfiniteLoading,
		TopAppBarSurveyListTab
	},

	mounted() {
		this.categoryName = this.$route.query.name;
	},

	updated() {
		const ripples = [].map.call(
			document.querySelectorAll(".ripple-item"),
			function (el) {
				let ripple = new MDCRipple.attachTo(el);
				return ripple;
			}
		);
	},

	methods: {
		// 목록 데이터 호출(get survey list data)
		fetchData($state) {
			let responseData = null;
			let params = this.setParams();

			if (this.totalPages >= this.currentPage) {
				surveyApi.guestSurveyIndependentList(params).then((response) => {
					let responseData = response.data.data;
					this.listData = this.listData.concat(responseData.content);
					this.currentPage++;
					this.totalPages = responseData.totalPages;

					if (responseData.content.length) {
						$state.loaded();
					} else {
						$state.complete();
					}
					if (!this.listData.length) {
						this.isNoData = true;
					}
				});
			} else {
				$state.complete();
			}
		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				category: this.$route.query.id,
				page: this.currentPage,
				size: 6,
				sort: "id,desc",
			};
			return params;
		},

		// 상세로 이동(move view)
		viewDetail(id) {
			this.$router.push({
				name: "IndependentSurveyTotalView",
				params: { distId: id },
				query: {listType: 'total'},
			});
		},
	},
};
</script>
